import React, { useEffect } from 'react';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-page">
      <section className="legal-hero">
        <div className="section-tag">LEGAL DOCUMENTATION</div>
        <h1 className="defense-headline" style={{ fontSize: '56px' }}>Privacy Policy</h1>
        <p className="defense-description">Last Updated: December 2025</p>
      </section>

      <section className="legal-content">
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '60px 20px' }}>
          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>1. Information Collection</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '20px' }}>
              Labana Dynamics OÜ collects information necessary for defense procurement processes, including:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>Organization and contact details</li>
              <li>Deployment requirements and specifications</li>
              <li>Security clearance information (where applicable)</li>
              <li>Technical inquiry data</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>2. Use of Information</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Information collected is used exclusively for:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>Processing quote requests and deployment planning</li>
              <li>Providing technical support and documentation</li>
              <li>Compliance with defense industry regulations</li>
              <li>Secure communication regarding active deployments</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>3. Data Security</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '20px' }}>
              All data is protected using military-grade encryption and stored in compliance with:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>GDPR (General Data Protection Regulation)</li>
              <li>ITAR (International Traffic in Arms Regulations)</li>
              <li>NATO security standards</li>
              <li>Estonian data protection laws</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>4. Information Sharing</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Labana Dynamics does not sell, trade, or transfer client information. Data may be shared only with:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>Government agencies for security clearance verification</li>
              <li>Authorized partners for deployment logistics (under NDA)</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>5. Data Retention</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Client data is retained for the duration of active contracts plus seven (7) years as required by defense industry regulations. Clients may request data deletion in writing, subject to regulatory retention requirements.
            </p>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>6. Contact for Privacy Concerns</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '10px' }}>
              For privacy-related inquiries, contact:
            </p>
            <p style={{ fontSize: '16px', color: '#D4AF37', lineHeight: '1.8' }}>
              Email: info@labanadynamics.com<br/>
              Subject: Privacy Inquiry - [Your Organization]
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;